// The Personal page's centred modal (Figma Followers 2745:1684, Edit profile 2745:1613, Payments 2745:1977): a 420px
// card on --bg-surface with a bold title and an X top right, over a dimmed page. Radix handles focus and Escape.
import type { ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

const SCRIM = "bg-[#0f172a]/50"; // theme-exempt: modal scrim, as the post dialog's, both themes

interface Props {
  title: ReactNode;
  /** Accessible name when the title is not plain text. */
  label?: string;
  testId?: string;
  onClose(): void;
  children: ReactNode;
  /** Card width in px (Figma: 420; Edit profile 342 at 1024 → 480). */
  width?: number;
}

export default function PersonalModal({ title, label, testId, onClose, children, width = 420 }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog.Root open onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={`fixed inset-0 z-[2000] ${SCRIM}`} />
        <Dialog.Content
          data-testid={testId}
          aria-describedby={undefined}
          aria-label={label}
          style={{ width }}
          className="fixed left-1/2 top-1/2 z-[2000] -translate-x-1/2 -translate-y-1/2 max-w-[calc(100vw-32px)] max-h-[calc(100dvh-32px)] overflow-y-auto rounded-2xl bg-[var(--bg-surface)] shadow-xl flex flex-col"
        >
          <div className="flex items-center gap-2 px-5 pt-5 pb-3">
            <Dialog.Title className="m-0 flex-1 min-w-0 truncate text-[18px] font-bold text-[var(--foreground)]">{title}</Dialog.Title>
            <Dialog.Close
              aria-label={t("wall_close", "Close")}
              className="flex items-center justify-center size-8 rounded-full text-[var(--foreground)] hover:bg-[var(--bg-hover)] cursor-pointer"
            >
              <X size={20} aria-hidden="true" />
            </Dialog.Close>
          </div>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
